const toggle = {
	el: {
		accordionToggle: document.querySelectorAll('.js-toggle-accordion'),
		filterToggle: document.querySelectorAll('.js-toggle-filter'),
		tableCaptionToggle: document.querySelectorAll('.js-toggle-caption'),
		asideList: document.querySelectorAll('.js-toggle-aside-list')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},

	fxToggleElement(el) {
		if (el) {
			el.forEach(el => el.addEventListener('click', e => {
				e.currentTarget.classList.toggle('is-toggled')
				e.currentTarget.nextElementSibling.classList.toggle(el.classList.contains('js-toggle-aside-list') || (el.classList.contains('js-toggle-filter') && this.vars.extraLargeAndUp.matches) ? 'is-toggle-close' : 'is-toggle-open')
				if (el.classList.contains('js-toggle-caption'))
					el.textContent = el.classList.contains('is-toggled') ? el.dataset.captionHide : el.dataset.captionShow
			}))
		}
	},

	events() {
		this.fxToggleElement(this.el.accordionToggle)
		this.fxToggleElement(this.el.filterToggle)
		this.fxToggleElement(this.el.tableCaptionToggle)
		if (this.vars.extraLargeAndUp.matches)
			this.fxToggleElement(this.el.asideList)
	},

	init() {
		this.events()
	}
}

toggle.init()